import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  message: string;
};

class AppErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message || 'Erreur inconnue' };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('UI crash captured by AppErrorBoundary', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-8">
          <div className="max-w-xl w-full bg-white border border-rose-200 rounded-2xl shadow-sm p-6">
            <h2 className="text-lg font-black text-rose-700 mb-2">Une erreur d'affichage est survenue</h2>
            <p className="text-sm text-slate-600 mb-4">
              L'application a empêché une page blanche. Rechargez la page puis réessayez.
            </p>
            <pre className="bg-slate-50 border border-slate-200 rounded-xl p-3 text-xs text-slate-700 overflow-auto whitespace-pre-wrap">
              {this.state.message}
            </pre>
            <div className="mt-4 flex gap-2">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-lg bg-indigo-600 text-white text-xs font-black"
              >
                Recharger
              </button>
              <button
                onClick={() => {
                  localStorage.removeItem('auth_token');
                  localStorage.removeItem('orion_crm_refresh_token');
                  window.location.reload();
                }}
                className="px-4 py-2 rounded-lg bg-slate-100 text-slate-700 text-xs font-black"
              >
                Revenir à la connexion
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
